import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {Scholarship} from "./scholarship";


const routes: Routes = [
  {
    path: 'scholarship',
    component: Scholarship,
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ScholarshipRoutingModule {}
